import { Form, Input, Modal, notification } from 'antd'
import { useState } from 'react'
import {
  buildTagCreateInput,
  buildTagUpdateInput,
  Tag,
  validateTagName,
} from './tagsAdminModel'
import { useCreateTagMutation, useUpdateTagMutation } from './tagsAdminQueries'

type Props = {
  open: boolean
  onClose: () => void
  /** When provided the modal renames/edits this tag; otherwise it creates one. */
  tag?: Tag
}

const TagEditorModal = ({ open, onClose, tag }: Props) => {
  const isEdit = tag != null
  const [name, setName] = useState(tag?.name ?? '')
  const [description, setDescription] = useState(tag?.description ?? '')
  const createMutation = useCreateTagMutation()
  const updateMutation = useUpdateTagMutation()
  const mutation = isEdit ? updateMutation : createMutation

  const reset = () => {
    setName(tag?.name ?? '')
    setDescription(tag?.description ?? '')
  }

  const handleClose = () => {
    reset()
    onClose()
  }

  const handleOk = () => {
    const validationError = validateTagName(name)
    if (validationError) {
      notification.error({ message: 'Invalid tag', description: validationError })
      return
    }
    if (isEdit && tag) {
      updateMutation.mutate(buildTagUpdateInput(tag, name, description), {
        onSuccess: handleClose,
      })
      return
    }
    createMutation.mutate(buildTagCreateInput(name, description), {
      onSuccess: handleClose,
    })
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      onOk={handleOk}
      okText="Save"
      title={isEdit ? 'Edit Tag' : 'New Tag'}
      confirmLoading={mutation.isLoading}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item label="Name" required style={{ marginBottom: 12 }}>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. security"
            autoFocus
          />
        </Form.Item>
        <Form.Item label="Description" style={{ marginBottom: 0 }}>
          <Input.TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional — what this tag groups."
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default TagEditorModal
